package br.com.vvrefeicoes.portal.core.ui.components

import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import br.com.vvrefeicoes.portal.core.ui.theme.AppShapes
import br.com.vvrefeicoes.portal.core.ui.theme.AppSpacing
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource

@Composable
fun AppToast(
    message: StringResource,
    modifier: Modifier = Modifier,
    formatArgs: List<Any> = emptyList(),
) {
    Surface(
        modifier = modifier,
        shape = AppShapes.large,
        color = MaterialTheme.colorScheme.onSurface,
        contentColor = MaterialTheme.colorScheme.surface,
        shadowElevation = 6.dp,
    ) {
        Text(
            text = stringResource(message, *formatArgs.toTypedArray()),
            style = MaterialTheme.typography.bodyMedium,
            modifier = Modifier.padding(horizontal = AppSpacing.space16, vertical = AppSpacing.space12),
        )
    }
}
